const initialState = {
    isTabScreen: false,
    isTabLargeScreen: false,
    isMobileLargeScreen: false,
    isMobileSmallScreen: false,
};

export const responsiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_RESPONSIVE':
            return {
                isTabScreen: action.payload.isTabScreen,
                isTabLargeScreen: action.payload.isTabLargeScreen,
                isMobileLargeScreen: action.payload.isMobileLargeScreen,
                isMobileSmallScreen: action.payload.isMobileSmallScreen,
            };
        case 'RESET_RESPONSIVE':
            return initialState;
        default:
            return state;
    }
};